import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectPecPaymentRequests: "selectPecPaymentRequests [Action]",
  selectPecPaymentRequestsLoading: "selectPecPaymentRequestsLoading [Action]",
  selectPecPaymentRequestsAsync: "selectPecPaymentRequestsAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const select_pec_payment_requests_Reducer = (
  state = inistiaState,
  { type, payload },
) => {
  switch (type) {
    case actionTypes.selectPecPaymentRequests:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.selectPecPaymentRequestsLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectPecPaymentRequestsLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "payment",
    method_type: "select_pec_payment_requests",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectPecPaymentRequests,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectPecPaymentRequestsLoading,
      payload: false,
    });
  }
}

export function* selectPecPaymentRequests() {
  yield takeLatest(actionTypes.selectPecPaymentRequestsAsync, handleWorker);
}
